<template>
	<article class="content list-page">
		<header>
			<h1>Payments</h1>
			<p class="gray-6">Manage your payment method, view payment history and upcoming charges.</p>
		</header>
		<section class="rigid cards cards-mixed row separated-extra relative">
			<div class="column flexible card card-primary">
				<h5 class="uppercase gray-5">Next payment</h5>
				<div class="row separated top rigid">
					<div class="flexible row separated-extra">
						<i class="rigid fas fa-calendar jumbo"></i>
						<spinner-new v-if="accountStatus.loading"></spinner-new>
						<div v-if="hasNextPayment" class="column separated rigid">
							<h3 class="rigid gray-7 no-margin">
								{{account.nextPayment.total | currency}}
							</h3>
							<small class="rigid gray-5">
								on {{account.nextPayment.processedDate | date}}
							</small>
						</div>

						<div v-else class="centered rigid">
							<div v-if="accountStatus.loading"  class="column separated placeholder-wrapper no-margin">
								<h3 class="rigid no-margin"></h3>
								<small class="rigid"></small>
							</div>
							<div v-else class="rigid gray-6 no-margin">
								No scheduled payment
							</div>
						</div>
					</div>
					<router-link v-if="hasNextPayment" class="rigid button" to="/payments/next">
						View
					</router-link>
				</div>
			</div>
			<div class="column flexible card card-secondary">
				<h5 class="uppercase gray-5">Payment Method</h5>
				<div class="row separated top rigid">
					<div class="flexible row separated-extra">
						<i class="rigid fas fa-credit-card jumbo"></i>

						<div v-if="account.paymentMethod" class="column separated rigid">
							<h3 class="rigid gray-7 no-margin">
								<i class="cc fab" :class="'fa-cc-' + account.paymentMethod.brand.toLowerCase()"></i> {{account.paymentMethod.last4}}
							</h3>
							<small class="rigid gray-5">
								expires {{account.paymentMethod.expiry | date}}
							</small>
						</div>

						<div v-else class="centered rigid">
							<div v-if="accountStatus.loading" class="column separated placeholder-wrapper no-margin">
								<h3 class="rigid no-margin"></h3>
								<small class="rigid"></small>
							</div>
							<div v-else class="rigid gray-6 no-margin">
								No card on file
							</div>
						</div>
					</div>
					<router-link v-if="!accountStatus.loading" class="rigid button" to="/payments/method">
						<span v-if="account.paymentMethod">Change</span>
						<span v-else>Add</span>
					</router-link>
				</div>
			</div>
		</section>

		<section>
			<header class="row baseline">
				<h3 class="flexible">Past Payments</h3>
				<h4 v-if="account.balance < 0" class="rigid no-margin gray-7"><span class="gray-5">Account Credit:</span> {{-account.balance | currency}}</h4>
			</header>
			<the-receipt-table :status="paymentStatus" :list="receipts"></the-receipt-table>
		</section>

	</article>
</template>

<script>
import SettingExpand from '../components/SettingExpand.vue';
import Collapsible from '../components/Collapsible.vue';
import SettingInput from '../components/SettingInput.vue';
import SettingStatic from '../components/SettingStatic.vue';
import TheReceiptTable from '../components/TheReceiptTable.vue';
import ReceiptView from '../components/ReceiptView.vue';
import Spinner from '../components/Spinner.vue';
import SpinnerNew from '../components/SpinnerNew.vue';
import date from '../filters/date.js';
import currency from '../filters/currency.js';
import { mapGetters } from 'vuex';

export default {
	name: 'Payments',
	computed: {
		...mapGetters([
			'account',
			'accountStatus'
		]),
		...mapGetters('payment', [
			'receipts',
			'paymentStatus'
		]),
		hasNextPayment() {
			return this.account.nextPayment && isFinite(this.account.nextPayment.total);
		},
		nextPaymentDetails() {
			return this.hasNextPayment && (this.$options.filters.currency(this.account.nextPayment.total) + ' on ' + this.$options.filters.date(this.account.nextPayment.processedDate)) || 'Next payment not available';
		},
		setReceiptsActive() {
			return this.$route.query && this.$route.query.active === 'receipts';
		},
		setPaymentMethodActive() {
			return this.$route.query && this.$route.query.active === 'payment';
		},
		showPastPayments() {
			// hide if no payments have been made
			return this.receipts && this.receipts.length > 0;
		}
	},
	components: {
		SettingInput,
		Collapsible,
		SettingExpand,
		SettingStatic,
		TheReceiptTable,
		Spinner,
		SpinnerNew,
		ReceiptView
	},
	filters: {
		date,
		currency
	},
	methods: {
		savePaymentMethod(token) {
			let vm = this;
			return new Promise((resolve, reject) => {
				this.$store.dispatch('ADD_PAYMENT_REQUEST', {
					type: 'stripe',
					token: token
				})
					.then(response => {
						resolve(response);
					})
					.catch(reason => {
						reject(reason);
					});
			});
		},
		resetPaymentState() {
			this.$store.dispatch('payment/RESET_PAYMENT_STATUS');
		},
		applyCouponCode() {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('USE_COUPON_REQUEST', this.couponCode)
					.then(response => {
						resolve(response);
					})
					.catch(reason => {
						reject(reason);
					});
			});
		}
	},
	watch:{
		    $route (to, from){
		        this.resetPaymentState();
		    }
	},
	created() {
		this.$store.dispatch('payment/GET_RECEIPTS_REQUEST');
		if (this.account.paymentMethod && !this.hasNextPayment) {
 				this.$store.dispatch('ACCOUNT_REQUEST');
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.placeholder-wrapper h3 {
		background: #ccc;
		width: 75px;
		height: 1em;
	}
	.dark .placeholder-wrapper h3 {
		background: #444;
	}
	.placeholder-wrapper small {
		background: #f2f2f2;
		width: 100px;
		height: 1em;
		display: flex;
	}
	.dark .placeholder-wrapper small {
		background: #222;
	}
	.card-secondary .placeholder-wrapper small {
		background: #eee;
	}
	.dark .card-secondary .placeholder-wrapper small {
		background: #333;
	}
</style>



// WEBPACK FOOTER //
// ./src/views/Payments.vue